import moment from 'moment'
import { useSelector } from 'react-redux'
import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'
import SectionHeader from './SectionHeader'
import SkillsBlock from './SkillsBlock'

const budgetTypeAbbr = { Hour: 'HR', Day: 'DAY', Week: 'WK', Month: 'MO', Year: 'YR' }

const RoleDetailsSection = () => {
  const skillListings = useSelector(
    (state) => state.oneUserskillListingReducer.skillListings?.skill_listings
  )

  const locations = (skillListings?.SkillListings_Cities || []).map(
    (c) => c?.Cities?.Location
  ).filter(Boolean)

  const startDate = skillListings?.IdealStartDate || skillListings?.StartDate
  const bidType = skillListings?.MinimumBidType || skillListings?.BudgetTypes?.BudgetTypeName
  const salary = skillListings?.MinimumBid != null
    ? `${Number(skillListings.MinimumBid).toLocaleString('en-US', { minimumFractionDigits: 2 })} /${budgetTypeAbbr[bidType] || bidType || 'YR'}`
    : '—'

  const roleDetails = [
    { icon: 'briefcase', label: 'Job Type', value: skillListings?.GigType || '—' },
    { icon: 'pin', label: 'Desired Location', chips: locations.length ? locations : null, value: '—' },
    { icon: 'calendar', label: 'Available to Start', value: startDate ? moment(startDate).format('MMM DD, YYYY') : '—' },
    { icon: 'money', label: 'Estimated Salary', value: salary },
  ]

  const skills = (skillListings?.SkillListings_Skills || []).map((s) => s?.SkillName).filter(Boolean)

  return (
    <section className={styles.card}>
      <SectionHeader title={skillListings?.Title || '—'} />

      <div className={styles.detailList}>
        {roleDetails.map((item) => (
          <div key={item.label} className={styles.detailItem}>
            <div className={styles.detailIconWrap}>
              <Icon name={item.icon} className={styles.detailIconSvg} />
            </div>

            <div className={styles.detailBody}>
              <div className={styles.detailLabel}>{item.label}</div>

              {item.chips ? (
                <div className={styles.detailChips}>
                  {item.chips.map((chip) => (
                    <span key={chip} className={styles.chipBlue}>
                      {chip}
                    </span>
                  ))}
                </div>
              ) : (
                <div className={styles.detailValue}>{item.value}</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <SkillsBlock skills={skills} />
    </section>
  )
}

export default RoleDetailsSection
